import { DEVICE_ALERTS_EVENTS } from '@/constants/device';

export const MAX_ALERT_CARDS = 3;

export const normalizeSseAlertForCard = (event) => {
  if (!event || typeof event !== 'object') {
    return null;
  }

  if (!event.message_type) {
    return null;
  }

  return {
    ...event,
    utc_timestamp:
      event.utc_timestamp ||
      event.insights_smart_home_alert_event__utc_timestamp ||
      event.insights_motion_alert_event__utc_timestamp ||
      event.insights_biometrics_alert_event__utc_timestamp ||
      '',
    display_text:
      event.display_text ||
      event.insights_smart_home_alert_event__display_text ||
      event.insights_motion_alert_event__display_text ||
      event.insights_biometrics_alert_event__display_text ||
      '',
  };
};

export const isSupportedDashboardAlertType = (messageType) =>
  Object.values(DEVICE_ALERTS_EVENTS).includes(messageType);

export const mergeAlertCards = (...alertGroups) =>
  alertGroups.flat().filter(Boolean).slice(0, MAX_ALERT_CARDS);

export const getTopApiAlerts = (alerts = []) =>
  [...alerts]
    .sort((a, b) => new Date(b.utc_timestamp) - new Date(a.utc_timestamp))
    .slice(0, MAX_ALERT_CARDS);
